var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-card"},[_c('div',{staticClass:"icon-card__body"},[_c('div',{staticClass:"icon-card__left-column"},[_vm._t("header"),_c('div',{staticClass:"icon-card__body-content"},[_vm._t("body")],2)],2),_c('div',{staticClass:"icon-card__right-column"},[_vm._t("icon")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }